import { render } from "./ChangelogObject.vue?vue&type=template&id=1caff507"
import script from "./ChangelogObject.vue?vue&type=script&lang=js"
export * from "./ChangelogObject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__